export default "__VITE_ASSET__CQNzAZe0__"